import { TTagOptionValue } from '@cian/ui-kit';

export const parseTagValue = (tagValue: TTagOptionValue): [string, string | undefined] => {
  const [id, value] = String(tagValue).split('-');

  return [id, value];
};
